'use strict';

/*
 created by zhang.yingyu 2018-11-20
 */
angular.module('iwoDepartmentManuscriptModule', []).controller('iwoDepartmentManuscriptCtrl', [
    '$scope',
    '$q',
    '$window',
    '$state',
    'modalDialog',
    '$stateParams',
    '$timeout',
    'trsHttpService',
    'initSingleSelecet',
    'storageListenerService',
    'myManuscriptService',
    'trsspliceString',
    'editingCenterService',
    'editIsLock',
    'editNewspaperService',
    'newMediaService',
    'iWoConst',
    'iWoService',
    function (
        $scope,
        $q,
        $window,
        $state,
        modalDialog,
        $stateParams,
        $timeout,
        trsHttpService,
        initSingleSelecet,
        storageListenerService,
        myManuscriptService,
        trsspliceString,
        editingCenterService,
        editIsLock,
        editNewspaperService,
        newMediaService,
        iWoConst,
        iWoService
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化状态函数开始
         * @return {[type]} [description] null
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
                ITEMCOUNT: 0,
                PAGECOUNT: 1,
            };
            $scope.status = {
                copyCurrPage: 1,
                isESSearch: false,
            };
            $scope.params = {
                serviceid: 'mlf_departoperdoc',
                methodname: 'quertDeptDocs',
                PageSize: $scope.page.PAGESIZE,
                CurrPage: $scope.page.CURRPAGE,
                DeptmentalDocId: $stateParams.departmentDocId,
            };
            $scope.data = {
                // 提交人输入框
                inputPerson: '',
                // 提交人初始下拉框数据
                submitPerson: [],
                items: [],
                selectedArray: [],
                fusionRouter: {
                    // 融合编辑器路由
                    '1': 'fusionnews',
                    '2': 'fusionatlas',
                    '4': 'fusionlinkdoc',
                    '5': 'fusionactivity',
                    '6': 'fusiontopic',
                    '7': 'fusionvideo',
                    '8': 'fusionlive',
                },
            };
            $scope.status = {
                departmentDocId: $state.params.departmentDocId,
                btnRights: {},
                hasphoto: false, // 是否是图集稿
                imgConcat: false, // 判断是否是图集，进行追加数组
                copyCurrPage: 1,
                hasphotoflag: true,
            };
            // 查询筛选提交人
            $scope.searchParams = {
                methodname: 'queryUsersByName',
                serviceid: 'mlf_extuser',
                IsSearchAll: true,
                Name: '',
            };
            $scope.childStatus = {
                // 图片数组的string
                checkString: 'DOC_PICTURELIST',
                // 图片数组中表示url地址的string
                picString: 'SRCPICURL',
                originPicUrl: 'SRCPICURL'
            };
        }

        /**
         * [initData description]初始化数据开始
         * @return {[type]} [description] null
         */
        function initData() {
            getDropDown();
            getDepartDocAuthority();
            listenStorage();
            getDepartPersonList();
        }

        // 用于记忆功能，在app.js中$transitions.onSuccess方法中调用
        $scope.requestData = function () {
            requestData();
        };

        /**
         * [getESSearchParams description]设置ES检索参数
         * @return {[json]} [description] 参数对象
         */
        function getESSearchParams() {
            var esParams = {
                serviceid: 'mlf_hybasesearch',
                methodname: 'queryForIwoDeptDoc',
                searchParams: {
                    PAGESIZE: $scope.page.PAGESIZE + '',
                    PAGEINDEX: $scope.page.CURRPAGE + '',
                    searchFields: [
                        {
                            searchField: $scope.iWoAllSelected.value,
                            keywords: $scope.keywords ? $scope.keywords : '',
                        },
                        {
                            searchField: 'docType',
                            keywords: $scope.params.DocType ? $scope.params.DocType : '',
                        },
                        {
                            searchField: 'submitUser',
                            keywords: $scope.data.inputPerson,
                        },
                        {
                            searchField: 'docStatus',
                            keywords: $scope.iWoDocStatuSelected.value,
                        },
                        {
                            searchField: 'timeType',
                            keywords:
                                angular.isDefined($scope.data.fromdate) && $scope.data.fromdate !== ''
                                    ? $scope.data.fromdate + ',' + $scope.data.untildate
                                    : $scope.timeType.value,
                        },
                        {
                            searchField: '_sort',
                            keywords: $scope.sortType.value,
                        },
                    ],
                },
                DeptmentalDocId: $stateParams.departmentDocId,
                MediaType: -2,
            };
            esParams.searchParams = JSON.stringify(esParams.searchParams);
            return esParams;
        }

        /**
         * [requestData description]获取部门稿库列表
         * @return {[type]}            [description]
         */
        function requestData() {
            var params = $scope.status.isESSearch ? getESSearchParams() : $scope.params;
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'POST').then(function (data) {
                $scope.data.items = [];
                var ListItems = data.DATA;
                $scope.data.items = ListItems;
                if ($scope.params.DocType && $scope.params.DocType === '2' && $scope.status.hasphotoflag === true) {
                    $scope.status.hasphoto = true;
                } else {
                    $scope.status.hasphoto = false;
                }
                $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT;
                $scope.page.PAGECOUNT = data.PAGER.PAGECOUNT;
                $scope.data.selectedArray = [];
                requestListImg(ListItems).then(function (data) {
                    angular.forEach(ListItems, function (value, key) {
                        value.ALLIMG = data[value.METADATAID];
                    });
                });
                getRelatedMediaIds(1)
                    .then(() => getRelatedInfo(ListItems))
                    .then((data) => {
                        angular.forEach(ListItems, function (value, key) {
                            value.relatedInfo = data[value.METADATAID];
                        });
                    });
                getRelatedMedias(ListItems).then(function (data) {
                    angular.forEach(ListItems, function (value, key) {
                        value.relatedMedias = data[value.METADATAID];
                    });
                });
            });
        }

        /**
         * [atlasMode description] 图集模式
         * @return {[type]} [description]
         */
        $scope.atlasMode = function () {
            $scope.status.hasphoto = !$scope.status.hasphoto;
            $scope.status.hasphotoflag = !$scope.status.hasphotoflag;
        };

        /**
         * [fullTextSearch description]检索
         * @param   {[type]}  ev  [ev description]
         * @return  {[type]}      [return description]
         */
        $scope.fullTextSearch = function (ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                $scope.status.isESSearch = true;
                $scope.page.CURRPAGE = 1;
                requestData();
            }
        };

        /**
         * [requestListImg description]查询列表图示
         * @param   {[type]}  items  [items description]
         * @return  {[type]}         [return description]
         */
        function requestListImg(items) {
            var defer = $q.defer();
            if (!items || items.length < 1) {
                defer.resolve([]);
            } else {
                var params = {
                    serviceid: 'mlf_myrelease',
                    methodname: 'queryAllImgLogo',
                    metadataids: trsspliceString.spliceString(items, 'METADATAID', ','),
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    defer.resolve(data);
                });
            }
            return defer.promise;
        }

        /**
         * [listenStorage description]监听本地缓存
         * @return {[promise]} [description] promise
         */
        function listenStorage() {
            storageListenerService.listenIwo(function () {
                requestData();
                storageListenerService.removeListener('iwo');
            }, $scope);
        }

        /**
         * [showVersionTime description]流程版本时间与操作日志
         * @param   {[type]}  item  [item description]稿件对象
         * @return  {[type]}        [return description]
         */
        $scope.showVersionTime = function (item) {
            editingCenterService.getVersionTime(item, false);
        };

        /**
         * [getDepartDocAuthority description]获取部门稿库权限
         *
         * @return  {[type]}  [return description]
         */
        function getDepartDocAuthority() {
            var params = {
                serviceid: 'mlf_metadataright',
                methodname: 'queryOperkeyOfDeptmentalDoc',
                DepartmentalDocId: $scope.status.departmentDocId,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                for (var i = 0; i < data.length; i++) {
                    $scope.status.btnRights[data[i]] = true;
                }
            });
        }

        /**
         * [submit description]提交
         * @return  {[type]}  [return description]
         */
        $scope.submit = function () {
            newMediaService.iwoSubmit($scope).then(() => {
                $scope.requestData(); // 为了串联单
            });
        };

        /**
         * [share description]部门稿库共享
         *
         * @return  {[type]}  [return description]
         */
        $scope.share = function () {
            newMediaService.iwoShare($scope, iWoConst.deptShare);
        };

        /**
         * [rejection description]退稿
         * @return {[type]} [description]null
         */
        $scope.rejection = function () {
            rejectionDraftofPage($scope.data.selectedArray);
        };

        /**
         * [rejectionDraftofPage description]
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        function rejectionDraftofPage(item) {
            var transferData = {
                item: item,
                rejecectionMethod: 'rejectionShangBanViewDatas',
                isDepartMent: true
            };
            editNewspaperService.rejectionDraft(
                transferData,
                function () {
                    requestData();
                },
                function () {
                    requestData();
                }
            );
        }

        /**
         * [manusTransmit description]部门之间传递稿件
         * @return  {[type]}  [return description]
         */
        $scope.manusTransmit = function () {
            newMediaService.iwoDepartSubmit($scope, 'manustransmit');
        };

        /**
         * [getRelatedMedias description] 查询已关联的渠道和关联渠道的虚拟稿件是否提交
         * @param  {[type]} items [description] 我的稿件
         * @return {[type]}       [description]
         */
        function getRelatedMedias(items) {
            var defer = $q.defer();
            if (!items || items.length < 1) {
                defer.resolve([]);
            } else {
                var params = {
                    serviceid: 'mlf_fusioncreate',
                    methodname: 'queryMediaRelateAndSubmitStatus',
                    MetaDataIds: trsspliceString.spliceString(items, 'METADATAID', ','),
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    defer.resolve(data);
                });
            }
            return defer.promise;
        }

        /**
         * [draftlist description]发稿单
         * @return  {[type]}  [return description]
         */
        $scope.draftlist = function () {
            editingCenterService.draftList(
                $scope.data.selectedArray,
                {
                    serviceid: 'mlf_appfgd',
                    methodname: 'iwoPersonbatchUpdateFgdUsers',
                },
                function () {
                    $scope.data.selectedArray = [];
                    requestData();
                }
            );
        };

        /**
         * [exportDraft description]导出稿件
         *
         * @return  {[type]}  [return description]
         */
        $scope.exportDraft = function () {
            $scope.status.isESSearch = false;
            var docIds = trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ',')
            $window.open('/wcm/app/file/download_file.jsp?docId=' + docIds);
            $scope.data.selectedArray = [];
            var params = {
                docId:docIds
            };
            trsHttpService.httpServer('/wcm/app/ct/video_info.jsp', params, 'get').then(
                function(data) {
                    if(data.length>0){
                        for(var i =0;i<data.length;i++){
                            $window.open('/transfer/aav/common/download?url=' + data[i]);
                        }
                    }
                }
            )
            // var params = {
            //     serviceid: 'mlf_exportword',
            //     methodname: 'exportWordFile',
            //     MetaDataIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
            // };
            // var falg = false;
            // for (var i = 0; i < $scope.data.selectedArray.length; i++) {
            //     if (!($scope.data.selectedArray[i].DOCTYPE === '新闻' || $scope.data.selectedArray[i].DOCTYPE === '图集')) {
            //         falg = true;
            //         break;
            //     }
            // }
            // if (falg) {
            //     modalDialog.alertType('只能导出新闻稿或图集稿', '', 'error', 'confirm', function () { });
            //     return false;
            // }
            // $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
            //     function (data) {
            //         window.open('/wcm/app/file/read_file.jsp?FileName=' + data.REPORTS[0].DETAIL);
            //     },
            //     function (data) {
            //         if (data.REPORTS[0].ISSUCCESS == 'true') {
            //             window.open('/wcm/app/file/read_file.jsp?FileName=' + data.REPORTS[0].DETAIL);
            //         }
            //     }
            // );
        };

        /**
         * [selectAll description]全选
         * @return {[type]} [description] null
         */
        $scope.selectAll = function () {
            $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
        };

        /**
         * [selectDoc description]单选
         * @param  {[object]} item [description] 单个对象
         * @return {[type]}      [description] null
         */
        $scope.selectDoc = function (item) {
            if ($scope.data.selectedArray.indexOf(item) < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
            }
        };

        /**
         * [getDropDown description]初始化下拉框
         *
         * @return  {[type]}  [return description]
         */
        function getDropDown() {
            // 排序方式
            $scope.sortTypeJsons = initSingleSelecet.sortType();
            $scope.sortType = angular.copy($scope.sortTypeJsons[1]);

            // 初始化全部
            $scope.iWoAll = initSingleSelecet.iWoEntire();
            $scope.iWoAllSelected = angular.copy($scope.iWoAll[0]);
            // 类型
            $scope.iWoDocTypes = initSingleSelecet.iDeptDocType();
            $scope.data.selectedDocType = angular.copy($scope.iWoDocTypes[0]);
            // 初始化选择日期
            $scope.timeTypeJsons = initSingleSelecet.iWoOperTime();
            $scope.timeType = angular.copy($scope.timeTypeJsons[0]);
            // 状态
            $scope.iWoDocStatus = [
                {
                    name: '全部状态',
                    value: '',
                },
                {
                    name: '待审',
                    value: '2',
                },
                {
                    name: '退稿',
                    value: '3',
                },
            ];
            $scope.iWoDocStatuSelected = angular.copy($scope.iWoDocStatus[0]);
            // editingCenterService.dealStorage($scope);
            // 下拉框单选结束
        }

        /**
         * [queryByDropdown description] 筛选条件触发后请求数据
         * @param  {[type]} key   [description] 请求对象参数key
         * @param  {[type]} value [description] 请求对象值
         * @return {[type]}       [description] null
         */
        $scope.queryByDropdown = function (key, value) {
            $scope.params[key] = value;
            $scope.params.CurrPage = $scope.status.copyCurrPage = $scope.page.CURRPAGE = '1';
            if (key === 'OperTime') {
                // 部门稿库日期特殊处理 --start
                var startDate = $scope.data.fromdate === '' ? '' : $scope.data.fromdate + ' 00:00:00';
                var endDate = $scope.data.untildate === '' ? '' : $scope.data.untildate + ' 23:59:59';
                // 部门稿库日期特殊处理 --end
                $scope.params.StartTime = startDate;
                $scope.params.EndTime = endDate;
                $scope.params[key] = null;
            }
            if (key === 'DocType' && value === '2') {
                $scope.status.hasphotoflag = true;
            }
            requestData();
        };

        /**
         * [pageChanged description]下一页
         *
         * @return  {[type]}  [return description]
         */
        $scope.pageChanged = function () {
            $scope.params.CurrPage = $scope.page.CURRPAGE;
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
        };

        /**
         * [jumpToPage description]跳转到指定页面
         * @return  {[type]}  [return description]
         */
        $scope.jumpToPage = function () {
            if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
            }
            $scope.params.CurrPage = $scope.status.copyCurrPage;
            $scope.page.CURRPAGE = $scope.status.copyCurrPage;
            requestData();
        };

        /**
         * [selectPageNum description]选择单页显示个数
         * @return {[type]} [description] null
         */
        $scope.selectPageNum = function () {
            $scope.params.PageSize = $scope.page.PAGESIZE;
            $scope.params.CurrPage = $scope.page.CURRPAGE;
            $scope.page.CURRPAGE = 1;
            requestData();
        };

        /**
         * [fusionPreview description] 融合编辑 预览
         * @param   {[Object]}  item    [item description] 稿件对象
         * @return  {[type]}            [return description]
         */
        $scope.fusionPreview = function (item) {
            myManuscriptService.queryDocStatus(item.DEPARTDOCRELID, 0, function () {
                myManuscriptService.fusionPreviewRouter(item, $scope);
            });
        };

        /**
         * [isLockEdit description]编辑前请求解锁
         * @param   {[type]}  item  [item description]稿件对象
         * @param   {[type]}  url   [url description]
         * @return  {[type]}        [return description]
         */
        function isLockEdit(item, url) {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_metadata',
                methodname: 'checkLock',
                MetaDataId: item.METADATAID,
                MediaType: -1,
                DepartmentalDocId: $scope.status.departmentDocId,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                if (data.ISLOCK === 'false') {
                    window.open(url);
                } else {
                    editIsLock.checkUnlockPermissions(item, data).then(function () {
                        $window.open(url);
                    });
                }
                defer.resolve(data);
            });
            return defer.promise;
        }

        /**
         * [fusionEditor description]融合编辑
         * @param   {[type]}  item   [item description] 稿件对象
         * @return  {[type]}         [return description]
         */
        $scope.fusionEditor = function (item) {
            // 没有编辑权限 跳转详情页
            if (!$scope.status.btnRights['deptmentaldoc.deptmentaldoc.bianji']) {
                $scope.fusionPreview(item);
                return;
            }
            myManuscriptService.queryDocStatus(item.DEPARTDOCRELID, 0, function () {
                myManuscriptService.fusionRouter(item, $scope);
            });
        };

        /**
        * [getRelatedMediaIds description] 获取关联渠道的相关id
        * @param {[type]} [doctype] [description] 稿件类型
        * @return {[type]} [description]
        */
        function getRelatedMediaIds(doctype) {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_fusioncreate',
                methodname: 'getMediaTypesByDocType',
                doctype: doctype,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                $scope.status.relatedChannelInfos = data;
                defer.resolve(data);
            });
            return defer.promise;
        }

        /**
         * [getRelatedInfo description] 获取关联信息
         * @param  {[type]} items [description] 稿件items
         * @return {[type]}       [description]
         */
        function getRelatedInfo(items) {
            let defer = $q.defer();
            if (!items || items.length < 1) {
                defer.resolve([]);
            } else {
                let params = {
                    serviceid: 'mlf_fusioncreate',
                    methodname: 'queryFuseMappingsByDocIds',
                    sourceDocIds: trsspliceString.spliceString(items, 'METADATAID', ','),
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    defer.resolve(data);
                });
            }
            return defer.promise;
        }

        /**
         * [getBindingMediaIds description] 获取绑定的渠道的相关id
         * @param {[type]} [iwometadataid] [description] iwo稿件id
         * @return {[type]} [description]
         */
        function getBindingMediaIds(iwometadataid) {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_fusioncreate',
                methodname: 'queryFuseMappings',
                sourceDocId: iwometadataid,
                mediaTypes: '',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                defer.resolve(data);
            });
            return defer.promise;
        }

        /**
         * [getRelatedMediaIcon description] 获取相关媒体的icon字
         * @param  {[type]} relatedMedia [description]
         * @return {[type]}              [description]
         */
        // $scope.getRelatedMediaIcon = function (relatedMedia) {
        //     if (relatedMedia.ISSUBMIT == '1') {
        //         relatedMedia.icon =
        //     relatedMedia.MEDIATYPE == '1'
        //         ? '#icon-duan-xuanzhong'
        //         : relatedMedia.MEDIATYPE == '2'
        //             ? '#icon-wang-xuanzhong1'
        //             : relatedMedia.MEDIATYPE == '3'
        //                 ? '#icon-bao-xuanzhong'
        //                 : relatedMedia.MEDIATYPE == '4'
        //                     ? '#icon-xin_s'
        //                     : relatedMedia.MEDIATYPE == '5'
        //                         ? '#icon-bo_s'
        //                         : '';
        //     } else {
        //         relatedMedia.icon =
        //     relatedMedia.MEDIATYPE == '1'
        //         ? '#icon-duan'
        //         : relatedMedia.MEDIATYPE == '2'
        //             ? '#icon-wang'
        //             : relatedMedia.MEDIATYPE == '3'
        //                 ? '#icon-bao'
        //                 : relatedMedia.MEDIATYPE == '4'
        //                     ? '#icon-xin'
        //                     : relatedMedia.MEDIATYPE == '5'
        //                         ? '#icon-bo'
        //                         : '';
        //     }
        // };
        /**
         * [getRelatedMediaIcon description] 获取相关媒体的icon字
         * @param  {[type]} relatedMedia [description]
         * @return {[type]}              [description]
         */
        $scope.getRelatedMediaIcon = function(relatedMedia) {
            iWoService.getRelatedMediaIcon(relatedMedia);
            // var iconObj = {};
            // if (relatedMedia.SUBMITSTATUS * 1 === 1) {
            //     iconObj = mediaIconObj.iconObj;
            // } else {
            //     iconObj = mediaIconObj.highlightIconObj;
            // }
            // relatedMedia.icon = iconObj[relatedMedia.MEDIATYPE];
        };

        /**
         * [reBasePerson description] 提交人选择后回调
         * @param   {[type]}  data  [data description] 回调数据
         * @return  {[type]}        [return description]
         */
        $scope.reBasePerson = function (data) {
            if (data.length === 0) {return;}
            $scope.data.inputPerson = data[0][data[0].length - 1].USERNAME;
            $scope.queryByDropdown('SubmitUser', data[0][data[0].length - 1].UNAME);
        };

        /**
         * [showSelectPerson description] 获取下一级的node数据
         * @param   {[Object]}  node  [node description] 当前需要请求的节点
         * @return  {[type]}          [return description]
         */
        $scope.showSelectPerson = function (node) {
            var deffer = $q.defer();
            if (node.HASCHILDREN === 'false') {
                const params = {
                    GroupId: node.GROUPID,
                    methodname: 'getUsersByGroup',
                    serviceid: 'mlf_group'
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    data.forEach((item) => {
                        item.GNAME = item.USERNAME;
                        item.chooseType = true;
                    });
                    deffer.resolve(data);
                });
            } else if (Object.keys(node).length === 0) {
                const params = {
                    methodname: 'queryGroupTreeWithMyPath',
                    serviceid: 'mlf_group'
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    deffer.resolve(data.CHILDREN);
                });
            } else if (node.chooseType) {
                $timeout(() => {
                    deffer.resolve([]);
                });
            } else {
                const params = {
                    GroupId: node.GROUPID,
                    methodname: 'queryChildGroupsWithOutRight',
                    serviceid: 'mlf_group'
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    deffer.resolve(data.CHILDREN);
                });
            }
            return deffer.promise;
        };

        /**
         * [getDepartPersonList description] 初始化搜索列表人员
         * @return  {[type]}  [return description]
         */
        function getDepartPersonList() {
            var params = JSON.parse(JSON.stringify($scope.params));
            params.methodname = 'quertDeptDocsSubmitUser';
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                $scope.PersonList = data;
            });
        }
        var promise;

        /**
         * [getSuggestions description] 获得输入的请求数据 输入字符串
         * @param   {[String]}  viewValue  [viewValue description]
         * @return  {[type]}             [return description]
         */
        $scope.getSuggestions = function (viewValue) {
            if (promise) {
                $timeout.cancel(promise);
                promise = null;
            }
            promise = $timeout(function () {
                var defer = $q.defer();

                /**
                 * [due description]
                 * @return  {[type]}  [return description]
                 */
                function due() {
                    if (!$scope.PersonList) {
                        $timeout(() => {
                            due();
                        }, 100);
                    } else {
                        if (viewValue !== '' && !angular.isObject(viewValue)) {
                            $scope.searchParams.Name = viewValue;
                            defer.resolve($scope.PersonList.filter((item) => item.USERNAME.includes(viewValue) === true));
                        } else if (viewValue === '') {
                            if ($scope.params.SubmitUser !== '') {
                                $scope.queryByDropdown('SubmitUser', '');
                            }
                            defer.resolve($scope.PersonList);
                        }
                    }
                }

                due();

                return defer.promise;
            }, 100);
            return promise;
        };
        // 监听选择事件返回
        $scope.$on('$typeahead.select', function (event, data) {// 监听在子控制器中定义的 sendParent 事件
            $scope.data.inputPerson = data.USERNAME;
            $scope.queryByDropdown('SubmitUser', data.UNAME);
        });

        /**
         * [goToDetail description] 图集模式跳转
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        $scope.goToDetail = function (item) {
            $scope.fusionPreview(item);
        };

        /**
         * [manuscriptShare description] 稿件分享
         * @param   {[object]}  item  [item description]
         * @return  {[type]}          [return description]
         */
        $scope.manuscriptShare = function(item) {
            $scope.loadingPromise = editingCenterService.manuscriptShare(item, function(data) {
                requestData();
            });
        };
        // 历史稿件
        $scope.historyDrafts = function() {
        	myManuscriptService.historyDrafts();
        };
    },
]);
